export default __webpack_public_path__ + "static/media/footer-bonuses-gift.9ba2e444.svg";